module.exports = __webpack_public_path__ + "media/10_4.193446ed.wav";